import shared from '@plato/app-shared/i18n/de.json' with { type: 'json' };
import activityFeed from '../locales/de/activity-feed.json' with { type: 'json' };
import askPlato from '../locales/de/ask-plato.json' with { type: 'json' };
import catalog from '../locales/de/catalog.json' with { type: 'json' };
import common from '../locales/de/common.json' with { type: 'json' };
import companyAddressTable from '../locales/de/company-address-table.json' with { type: 'json' };
import companyContactTable from '../locales/de/company-contact-table.json' with { type: 'json' };
import createCustomerAddressForm from '../locales/de/create-customer-address-form.json' with { type: 'json' };
import createCustomerContactForm from '../locales/de/create-customer-contact-form.json' with { type: 'json' };
import customerDetail from '../locales/de/customer-detail.json' with { type: 'json' };
import customersList from '../locales/de/customers-list.json' with { type: 'json' };
import dashboard from '../locales/de/dashboard.json' with { type: 'json' };
import events from '../locales/de/events.json' with { type: 'json' };
import explorer from '../locales/de/explorer.json' with { type: 'json' };
import filters from '../locales/de/filters.json' with { type: 'json' };
import genericList from '../locales/de/generic-list.json' with { type: 'json' };
import insightsTriage from '../locales/de/insights-triage.json' with { type: 'json' };
import insights from '../locales/de/insights.json' with { type: 'json' };
import lineItemTable from '../locales/de/line-item-table.json' with { type: 'json' };
import notes from '../locales/de/notes.json' with { type: 'json' };
import opportunities from '../locales/de/opportunities.json' with { type: 'json' };
import orderLineStatus from '../locales/de/order-line-status.json' with { type: 'json' };
import orderStatus from '../locales/de/order-status.json' with { type: 'json' };
import presetDatePicker from '../locales/de/preset-date-picker.json' with { type: 'json' };
import productDetails from '../locales/de/product-details.json' with { type: 'json' };
import quotesOrdersActions from '../locales/de/quotes-orders-actions.json' with { type: 'json' };
import quotesOrdersHeader from '../locales/de/quotes-orders-header.json' with { type: 'json' };
import quotesOrdersLineActions from '../locales/de/quotes-orders-line-actions.json' with { type: 'json' };
import quotesOrdersLineItems from '../locales/de/quotes-orders-line-items.json' with { type: 'json' };
import quotesOrdersList from '../locales/de/quotes-orders-list.json' with { type: 'json' };
import quotes from '../locales/de/quotes.json' with { type: 'json' };
import reorders from '../locales/de/reorders.json' with { type: 'json' };
import salesDraft from '../locales/de/sales-draft.json' with { type: 'json' };
import salesHistory from '../locales/de/sales-history.json' with { type: 'json' };
import tableCommon from '../locales/de/table-common.json' with { type: 'json' };
import tableProductAvailibity from '../locales/de/table-product-availibity.json' with { type: 'json' };
import tapiIntegration from '../locales/de/tapi-integration.json' with { type: 'json' };
import tasks from '../locales/de/tasks.json' with { type: 'json' };
import team from '../locales/de/team.json' with { type: 'json' };
import toasts from '../locales/de/toasts.json' with { type: 'json' };
import transactionDetails from '../locales/de/transaction-details.json' with { type: 'json' };

export const deTranslations = {
    'activity-feed': activityFeed,
    'ask-plato': askPlato,
    catalog: catalog,
    common: common,
    'company-address-table': companyAddressTable,
    'company-contact-table': companyContactTable,
    'create-customer-address-form': createCustomerAddressForm,
    'create-customer-contact-form': createCustomerContactForm,
    'customer-detail': customerDetail,
    'customers-list': customersList,
    dashboard: dashboard,
    explorer: explorer,
    filters: filters,
    'generic-list': genericList,
    insights: insights,
    'insights-triage': insightsTriage,
    'line-item-table': lineItemTable,
    notes: notes,
    opportunities: opportunities,
    'preset-date-picker': presetDatePicker,
    'product-details': productDetails,
    quotes: quotes,
    'quotes-orders-actions': quotesOrdersActions,
    'quotes-orders-header': quotesOrdersHeader,
    'quotes-orders-line-actions': quotesOrdersLineActions,
    'quotes-orders-line-items': quotesOrdersLineItems,
    'quotes-orders-list': quotesOrdersList,
    reorders: reorders,
    'sales-draft': salesDraft,
    'sales-history': salesHistory,
    shared: shared,
    'table-common': tableCommon,
    'table-product-availibity': tableProductAvailibity,
    'tapi-integration': tapiIntegration,
    tasks: tasks,
    toasts: toasts,
    'transaction-details': transactionDetails,
    events: events,
    'order-line-status': orderLineStatus,
    'order-status': orderStatus,
    team: team,
};
